import {FormField} from 'platform/components';
import {VStack} from 'platform/foundation';
import {z} from 'zod';

import {useListWarrantyProgramQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {BulkOperationForm, type BulkOperationActionCallbackParams} from 'features/eag-grid';

const VehicleWarrantyBulkFormSchema = z.object({
  warrantyProgramId: z.string().uuid(),
  warrantyDuration: z.number().int().positive(),
});

export function VehicleWarrantyBulkForm(props: {action: BulkOperationActionCallbackParams}) {
  const {currentData: programs = [], isFetching, isError} = useListWarrantyProgramQuery();
  return (
    <BulkOperationForm
      action={props.action}
      onError={handleApiError}
      experimentalZodSchema={VehicleWarrantyBulkFormSchema}
      defaultValues={{warrantyProgramId: '', warrantyDuration: undefined}}
      isDisabled={isFetching || isError}
      toParams={(values) => values}
    >
      {(control, formApi) => (
        <VStack spacing={3}>
          <FormField
            type="choice"
            control={control}
            name="warrantyProgramId"
            label={i18n.t('entity.warranty.labels.warrantyProgram')}
            options={programs.map((program) => ({value: program.id, label: program.name}))}
            onChange={(value) =>
              formApi.setValue(
                'warrantyDuration',
                programs.find((program) => program.id === value)?.duration ?? 0
              )
            }
            isLoading={isFetching}
            menuInPortal
            isRequired
          />
          <FormField
            type="integer"
            control={control}
            name="warrantyDuration"
            label={i18n.t('entity.vehicle.labels.warrantyDuration')}
            isRequired
          />
        </VStack>
      )}
    </BulkOperationForm>
  );
}
